export const config = {
  host: 'https://images-api.nasa.gov/'  
};



// WEBPACK FOOTER //
// ./src/config.js